import { Box, Button, Grid, useTheme } from "@mui/material";
import OrderChart from "./DashChartOrder/OrderChart.jsx";
import OrderAssignToDesigner from "./DesignerChart/OrderAssignToDesigner.jsx";
import CustomerOrderRegisterCountChart from "./DashChartCustomer/CustomerOrderRegisterCountChart.jsx";
import PlateAreaChart from "./DashChartPlate/PlateAreaChart.jsx";
import DesignerResultChart from "./PersonChart/Designer/DesignerResultChart.jsx";
import AvrageKlischePrice from "./AvrageKlischePrice/AvrageKlischePrice.jsx";
import PersonLeave from "./PersonLeave/PersonLeave.jsx";
import useDeviceType from "../../global/Hooks/useDeviceType.js";
import PersonLeaveMobile from "./PersonLeave/mobile/PersonLeaveMobile.jsx";
import useDashboardContainer from "./components/useDashboardContainer.js";
import DashChartDamagePlate from "./DashChartDamagePlate/DashChartDamagePlate.jsx";
import { useInView } from "@react-spring/web";
import OrderCountChartCustomer from "./OrderCountChartForCustomer/OrderCountChartCustomer.js";
import useGetRoles from "../../../General/Hooks/useGetRoles.js";
import OrderCompareChart from "./OrderCompareChart/OrderCompareChart.jsx";
import Layout from "./components/Layout.js";
import InvoicePriceChart from "./InvoicePriceChart/InvoicePriceChart.jsx";
import HourlyChart from "./HourlyChart/HourlyChart.jsx";
import ReportOfSalesExperts from "./ReportOfSalesExperts/ReportOfSalesExperts.jsx";
import { useState } from "react";
import Chart from "../Chart/Chart.jsx";

function DashboardChart() {
  const theme = useTheme().palette.mode;

  const [refDamage, inViewDamage] = useInView({
    triggerOnce: true,
    once: true,
  });
  const [refPlateArea, inViewPlateArea] = useInView({
    triggerOnce: true,
    once: true,
  });
  const [refOrder, inViewOrder] = useInView({ triggerOnce: true, once: true });
  const [refKlischePrice, inViewKlischePrice] = useInView({
    triggerOnce: true,
    once: true,
  });
  const [refInvoicePrice, inViewInvoicePrice] = useInView({
    triggerOnce: true,
    once: true,
  });
  const [refHourlyChart, inViewHourlyChart] = useInView({
    triggerOnce: true,
    once: true,
  });
  const [refOrderAssignToDesigner, inViewOrderAssignToDesigner] = useInView({
    triggerOnce: true,
    once: true,
  });
  const [refOrderCompareChart, inViewOrderCompareChart] = useInView({
    triggerOnce: true,
    once: true,
  });
  const roles = useGetRoles();
  const hasCustomer = roles.some((role) => role.roleName === "Customer");
  const deviceType = useDeviceType();
  const { access, chartsAccess } = useDashboardContainer();
  const [activeChart, setActiveChart] = useState("all");

  const {
    CustomerOrderRegisterCountChartAccess,
    DesignerOrderRegisterCountChart,
    GetAccessAvrageKlischePrice,
    GetAccessPersonLeave,
    GetPersonDesignerChart,
    GetPlateAreaChartAccess,
    OrderCountChartAccess,
    palateDamage,
    GetAccessOrderCompare,
    getInvoicePriceChart,
    getHourlyOrderRegisterCountChart,
  } = access;

  const buttons = [
    { key: "all", label: "نمودارها" },
    { key: "order", label: "سفارشات" },
    { key: "customer", label: "مشتریان" },
    { key: "saleExpert", label: "کارشناسان فروش" },
    { key: "hourly", label: "ساعتی" },
    { key: "designer", label: "طراحان" },
    { key: "damage", label: "خرابی" },
    { key: "production", label: "تولید" },
    { key: "price", label: "قیمت" },
    { key: "compare", label: "مقایسه" },
  ];

  return (
    <>
      {GetAccessPersonLeave && (
        <Grid item width={"100%"} xs={12} lg={12}>
          {deviceType === "mobile" ? <PersonLeaveMobile /> : <PersonLeave />}
        </Grid>
      )}
      
          <Chart />
       
      {/* {GetAccessPersonLeave && (
        <Box
          sx={{
            display: "inline-flex",
            flexWrap: "wrap",
            gap: 1,
            p: 1,
            mb: 2,
            border: `1px solid ${theme === "light" ? "#E0E0E0" : "#353841"}`,
            borderRadius: "12px",
            backgroundColor: theme === "light" ? "#fff" : "#1E232D",
          }}
        >
          {buttons.map((btn) => {
            const isActive = activeChart === btn.key;

            return (
              <Button
                key={btn.key}
                size="small"
                onClick={() => setActiveChart(btn.key)}
                sx={{
                  px: 2,
                  py: "4px",
                  fontSize: "12px",
                  borderRadius: "14px",
                  textTransform: "none",

                  color: "#1E6AFD",
                  border: "1px solid #1E6AFD",
                  backgroundColor: isActive ? "#E6F1FF" : "transparent",

                  "&:hover": {
                    backgroundColor: "#E6F1FF",
                  },
                }}
              >
                {btn.label}
              </Button>
            );
          })}
        </Box>
      )} */}

      {/* {(activeChart === "all" || activeChart === "order") &&
        OrderCountChartAccess &&
        chartsAccess.includes("orderChart") && (
          <Grid ref={refOrder} item xs={12}>
            {inViewOrder && (
              <Layout>
                <OrderChart />
              </Layout>
            )}
          </Grid>
        )} */}

      {/* گزارش مشتریان برتر */}
      {/* {(activeChart === "all" || activeChart === "customer") &&
        CustomerOrderRegisterCountChartAccess &&
        chartsAccess.includes("customerChart") && (
          <CustomerOrderRegisterCountChart />
        )} */}

      {/* گزارش کارشناسان فروش */}
      {/* {(activeChart === "all" || activeChart === "saleExpert") &&
        access.getSalesExpertInvoicePriceChart &&
        chartsAccess.includes("saleExpertChart") && (
          <Grid item xs={12}>
            <Layout>
              <ReportOfSalesExperts />
            </Layout>
          </Grid>
        )} */}

      {/* گزاش سفارشات - ساعت */}

       {/* {(activeChart === "all" || activeChart === "hourly") &&
        getHourlyOrderRegisterCountChart &&
        chartsAccess.includes("orderHourChart") && (
          <Grid ref={refHourlyChart} item xs={12}>
            {inViewHourlyChart && <HourlyChart />}
          </Grid>
        )}  */}

      {/**  گزارش قیمت فاکتور */}
      {/* {getInvoicePriceChart && chartsAccess.includes("invoiceChart") && (
        <Grid ref={refInvoicePrice} item width={"100%"} xs={12} lg={12}>
          {inViewInvoicePrice ? (
            <Layout>
              <InvoicePriceChart />
            </Layout>
          ) : (
            <></>
          )}
        </Grid>
      )}  */}
      {/* گزارش طراحان */}
      {/* {(activeChart === "all" || activeChart === "designer") &&
        DesignerOrderRegisterCountChart &&
        chartsAccess.includes("designerChart") && (
          <Grid ref={refOrderAssignToDesigner} item xs={12}>
            {inViewOrderAssignToDesigner && (
              <Layout>
                <OrderAssignToDesigner />
              </Layout>
            )}
          </Grid>
        )} */}

      {/* گزارش خرابی */}
      {/* {(activeChart === "all" || activeChart === "damage") &&
        palateDamage &&
        chartsAccess.includes("damagePlateChart") && (
          <Grid ref={refDamage} item xs={12}>
            {inViewDamage && (
              <Layout>
                <DashChartDamagePlate />
              </Layout>
            )}
          </Grid>
        )} */}

      {/* گزارش تولید */}
      {/* <Grid container spacing={2}>
        {(activeChart === "all" || activeChart === "production") &&
          GetPlateAreaChartAccess &&
          chartsAccess.includes("productionChart") && (
            <Grid ref={refPlateArea} item xs={12}>
              {inViewPlateArea && (
                <Layout>
                  <PlateAreaChart />
                </Layout>
              )}
            </Grid>
          )} */}

        {/* گزارش کارکرد هر طراح */}
        {/* {GetPersonDesignerChart && (
          <Grid item width={"100%"} xs={12} lg={12}>
            <Layout>
              <DesignerResultChart />
            </Layout>
          </Grid>
        )} */}

        {/* گزارش قیمت فروش */}
        {/* {(activeChart === "all" || activeChart === "price") &&
          GetAccessAvrageKlischePrice &&
          chartsAccess.includes("priceChart") && (
            <Grid ref={refKlischePrice} item xs={12}>
              {inViewKlischePrice && (
                <Layout>
                  <AvrageKlischePrice />
                </Layout>
              )}
            </Grid>
          )}
      </Grid> */}

      {/* گزارش مقایسه */}
      {/* {(activeChart === "all" || activeChart === "compare") &&
        GetAccessOrderCompare &&
        chartsAccess.includes("compareChart") && (
          <Grid ref={refOrderCompareChart} item xs={12}>
            {inViewOrderCompareChart && (
              <Layout>
                <OrderCompareChart />
              </Layout>
            )}
          </Grid>
        )} */}
    </>
  );
}

export default DashboardChart;
